import { useContext } from "react";
import {
  CurrentBranchContext,
  CurrentBranchContextType,
} from "./CurrentBranchContext";

export const useCurrentBranch = (): CurrentBranchContextType => {
  const context = useContext(CurrentBranchContext);
  if (!context) {
    throw new Error(
      "useCurrentBranch must be used within a CurrentBranchProvider",
    );
  }
  return context;
};
